import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './index.css';
import { Provider } from 'react-redux';
//import { PersistGate } from 'redux-persist/integration/react';
import store from './store.js';
import 'react-toastify/dist/ReactToastify.css'
import ToastContainerComponent from './component/ToastContainerComponent.js';
import { ThemeProvider } from '@emotion/react';
import { customTheme } from './theme.js';


const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

if (recaptchaSiteKey) {
  const script = document.createElement("script");

  script.src = `https://www.google.com/recaptcha/enterprise.js?render=${recaptchaSiteKey}`;
  script.async = true;
  script.defer = true;

  document.head.appendChild(script);
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
     <ThemeProvider theme={customTheme}>
        <App />
    </ThemeProvider>
      <ToastContainerComponent/>
    </Provider>
  </React.StrictMode>,
);
